import React from 'react'
import { Link } from 'react-router-dom'

import SEO from '../components/SEO'
import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './iletisim.css'

const GOOGLE_MAPS_DIRECTIONS_URL =
  'https://www.google.com/maps?gs_lcrp=EgZjaHJvbWUqCAgAEEUYJxg7MggIABBFGCcYOzIGCAEQRRg5MgYIAhAjGCcyDwgDEC4YQxixAxiABBiKBTIHCAQQABiABDIGCAUQRRg8MgYIBhBFGDwyBggHEEUYPdIBCDEyMDFqMGo3qAIAsAIA&um=1&ie=UTF-8&fb=1&gl=tr&sa=X&geocode=KcO3fGSQt8oUMU8tXf2eHzZ-&daddr=Conrad+%C4%B0stanbul+Bosphorus+Otopark%C4%B1,+Cihann%C3%BCma,+Saray+Cd+No:5,+34351+Be%C5%9Fikta%C5%9F/%C4%B0stanbul'

const Iletisim = () => {
  return (
    <div className="contact-page-container teleport-dashboard-layout">
      <SEO
        title="İletişim & Stüdyo Randevu | Beşiktaş | ATEŞ AUTO DETAILING"
        description="Conrad Istanbul Bosphorus Otoparkı içerisindeki stüdyomuzu ziyaret edin. PPF kaplama, seramik koruma ve detailing randevusu için hemen arayın."
        canonicalPath="/iletisim"
      />

      <aside className="contact-sidebar-wrapper teleport-dashboard-sidebar">
        <Navigation />
      </aside>

      <main id="tq-main" className="contact-content-wrapper teleport-dashboard-content">
        <section className="contact-hero">
          <nav aria-label="Breadcrumb" className="contact-breadcrumb">
            <Link to="/">ANA SAYFA</Link>
            <span className="contact-breadcrumb-separator">/</span>
            <span aria-current="page">İLETİŞİM</span>
          </nav>

          <h1 className="contact-headline">İletişim &amp; Stüdyo Randevu</h1>

          <p className="contact-description">
            Aracınız için en uygun koruma ve detailing çözümlerini değerlendirmek, fiyat teklifi almak ve
            stüdyo randevusu oluşturmak için bizimle iletişime geçebilirsiniz.
          </p>
        </section>

        <section className="contact-body">
          <div className="contact-grid">
            {/* Kart 1: Telefon ile İletişim */}
            <div className="contact-card">
              <span className="contact-card-badge">DOĞRUDAN ARAMA</span>
              <h2 className="contact-card-title">Telefon Hatlarımız</h2>
              <p className="contact-card-text">
                Uygulama süreçleri, müsaitlik durumu ve genel danışma için doğrudan stüdyomuzu arayabilirsiniz.
              </p>
              <div className="contact-actions-vertical">
                <a href="tel:05346442153" className="contact-phone-btn">
                  <span className="contact-phone-label">MOBİL / DESTEK:</span>
                  <span className="contact-phone-val">0534 644 21 53</span>
                </a>
                <a href="tel:02124412153" className="contact-phone-btn">
                  <span className="contact-phone-label">STÜDYO SABİT:</span>
                  <span className="contact-phone-val">0212 441 21 53</span>
                </a>
              </div>
            </div>

            {/* Kart 2: WhatsApp Doğrudan Mesaj */}
            <div className="contact-card">
              <span className="contact-card-badge">HIZLI TEKLİF &amp; FOTOĞRAF</span>
              <h2 className="contact-card-title">WhatsApp Hattı</h2>
              <p className="contact-card-text">
                Aracınızın modelini ve yaptırmak istediğiniz işlemi ileterek stüdyomuzdan hızlı bilgi ve ön teklif alabilirsiniz.
              </p>
              <div className="contact-actions-vertical">
                <a
                  href="https://wa.me/905346442153"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="contact-whatsapp-btn"
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M18.497 4.409a10 10 0 0 1-10.36 16.828l-.223-.098l-4.759.849l-.11.011a1 1 0 0 1-.11 0l-.102-.013l-.108-.024l-.105-.037l-.099-.047l-.093-.058l-.014-.011l-.012-.007l-.086-.073l-.077-.08l-.067-.088l-.056-.094l-.034-.07l-.04-.108l-.028-.128l-.012-.102a1 1 0 0 1 0-.125l.012-.1l.024-.11l.045-.122l1.433-3.304l-.009-.014A10 10 0 0 1 5.056 4.83l.215-.203a10 10 0 0 1 13.226-.217M9.5 7.5A1.5 1.5 0 0 0 8 9v1a6 6 0 0 0 6 6h1a1.5 1.5 0 0 0 0-3h-1l-.144.007a1.5 1.5 0 0 0-1.128.697l-.042.074l-.022-.007a4.01 4.01 0 0 1-2.435-2.435l-.008-.023l.075-.041A1.5 1.5 0 0 0 11 10V9a1.5 1.5 0 0 0-1.5-1.5" />
                  </svg>
                  <span>WhatsApp ile Mesaj Gönder</span>
                </a>
              </div>
            </div>

            {/* Kart 3: Konum ve Çalışma Saatleri */}
            <div className="contact-card">
              <span className="contact-card-badge">LOKASYON &amp; ZAMAN</span>
              <h2 className="contact-card-title">Stüdyo Adresi</h2>
              <address className="contact-card-text" style={{ fontStyle: 'normal' }}>
                <strong>ATEŞ AUTO DETAILING</strong><br />
                Conrad İstanbul Bosphorus Otoparkı<br />
                Cihannüma Mahallesi, Saray Caddesi No:5<br />
                34351 Beşiktaş / İstanbul
              </address>
              <a
                href={GOOGLE_MAPS_DIRECTIONS_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="contact-directions-btn"
                aria-label="Google Haritalar'da yol tarifi al"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <polygon points="3 11 22 2 13 21 11 13 3 11" />
                </svg>
                <span>Google Haritalar&apos;da Yol Tarifi Al</span>
              </a>
              <div style={{ marginTop: 'auto', paddingTop: '1rem', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
                <span style={{ fontSize: '0.72rem', color: '#ff6b2a', fontFamily: 'Orbitron', fontWeight: '700', letterSpacing: '0.08em', display: 'block', marginBottom: '0.35rem' }}>
                  ÇALIŞMA SAATLERİ
                </span>
                <p style={{ margin: 0, fontSize: '0.9rem', color: 'rgba(255,255,255,0.8)', lineHeight: 1.5 }}>
                  Pazartesi – Cumartesi: 08:30 – 19:00<br />
                  Pazar: Kapalı
                </p>
              </div>
            </div>
          </div>

          {/* Stüdyo Randevu Bildirimi */}
          <div className="contact-studio-box">
            <span className="contact-studio-title">RANDEVU İLE HİZMET PRENSİBİ</span>
            <p className="contact-studio-text">
              Stüdyomuzda her araca hak ettiği özenin gösterilmesi ve kontrollü kapalı alanda işlem yapılabilmesi amacıyla
              randevu usulüyle çalışmaktayız. Aracınızı stüdyomuza getirmeden önce lütfen telefon veya WhatsApp hattımız üzerinden
              müsaitlik teyidi alınız.
            </p>
          </div>
        </section>

        <Footer />
      </main>
    </div>
  )
}

export default Iletisim
